import { useEffect, useState } from "react";

const OptionToggler = ({
  name,
  options,
  defaultValue,
  onSelectFn,
  disabled = false,
  showRadio = false,
  tabIndex,
}) => {
  const [selectedOption, setSelectedOption] = useState(defaultValue);

  useEffect(() => {
    setSelectedOption(defaultValue);
  }, [defaultValue]);

  const handleOptionChange = (value) => {
    if (onSelectFn) {
      onSelectFn(value);
    }
    setSelectedOption(value);
  };

  if (showRadio) {
    return (
      <div className={`option-toggler${disabled ? " disabled" : ""}`}>
        {options.map((option) => {
          const id = `${name}-${option.value}`;
          return (
            <div
              key={option.value}
              className={`input-wrapper${
                selectedOption === option.value ? " active" : ""
              }`}
            >
              <input
                type="radio"
                id={id}
                name={name}
                value={option.value}
                checked={selectedOption === option.value}
                onChange={() => handleOptionChange(option.value)}
                disabled={disabled}
                tabIndex={tabIndex}
              />
              <label htmlFor={id} className="radio-input">
                <span className="radio" />
                <span className="text">{option.label}</span>
              </label>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className={`option-toggler${disabled ? " disabled" : ""}`}>
      {options.map((option) => (
        <label
          key={option.value}
          className={selectedOption === option.value ? "active" : ""}
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedOption === option.value}
            onChange={() => handleOptionChange(option.value)}
            disabled={disabled}
            tabIndex={tabIndex}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default OptionToggler;
